import { Flex, useMessagedAsyncRetry, usePaypingContext } from "@payping/web-components";
import { useAppDispatch } from "@/utils";
import {
  getBalance,
  getBusinessSetting,
  getUserOverviewTasksStatus,
  getUserWithdrawStatus,
} from "@payping/redux/actions";
import Notifications from "./Notifications";
import CompleteProfile from "./CompleteProfile";
import Tasks from "./Tasks";
import LinksBoard from "./LinksBoard";
import PaymentCard from "./paymentCard";
import SettlementCard from "./SettlementCard";
import ReportMobile from "./Report/Mobile";
import ReportDesktop from "./Report/Desktop";
import UnreadMessageNotification from "./UnreadMessageNotification";

const Main = () => {
  const dispatch = useAppDispatch();

  const { breakpoints } = usePaypingContext();
  const { md } = breakpoints;

  const { loading: businessSettingLoading } = useMessagedAsyncRetry(() => dispatch(getBusinessSetting()), [dispatch], {
    success: false,
  });
  const { loading: withdrawStatusLoading } = useMessagedAsyncRetry(
    () => dispatch(getUserWithdrawStatus()),
    [dispatch],
    {
      success: false,
    },
  );
  const { loading: tasksStatusLoading } = useMessagedAsyncRetry(
    () => dispatch(getUserOverviewTasksStatus()),
    [dispatch],
    {
      success: false,
    },
  );

  useMessagedAsyncRetry(() => dispatch(getBalance()), [dispatch], {
    success: false,
  });

  return (
    <main className="w-100">
      <Flex vertical gap="16px" className="w-100" justify="center" align="center">
        {/* <> */}
        <Notifications />

        {/* < کارت تکمیل پروفایل > */}
        <CompleteProfile isLoading={withdrawStatusLoading || businessSettingLoading} />

        <SettlementCard />

        {/* < کارت آنبردینگ > */}
        <Tasks isLoading={tasksStatusLoading} />

        {/* < کارت معرفی خدمات  > */}
        <LinksBoard withdrawListLoading={withdrawStatusLoading} />

        {/* < کارت تسویه > */}
        <PaymentCard isLoading={withdrawStatusLoading || businessSettingLoading} />

        {/* <کارت نمودار > */}
        <div className={"w-100"} style={{ marginBottom: "24px" }}>
          {md ? <ReportDesktop /> : <ReportMobile />}
        </div>
      </Flex>
      <UnreadMessageNotification />
    </main>
  );
};

export default Main;
